module.exports = __webpack_public_path__ + "media/images/countrysquared/ug-efbf46a745388f9e077691cc080eaff8.svg";